<script setup lang="ts">
import type { ValidData } from '@/components/forms/LoginForm.vue';

import { ref } from 'vue';

import LoginForm from '@/components/forms/LoginForm.vue';
import router from '@/router';
import { fetchLogIn } from '@/helpers/fetchers';
import loginBgUrl from '@brand-assets/login-bg.jpg';

const isLoading = ref<boolean>(false);

const handleSubmit = async (formData: ValidData): Promise<void> => {
  isLoading.value = true;
  try {
    await fetchLogIn(formData);
    await router.push('/');
  } catch {
    // Error already handled: notification shown, Sentry reported
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <v-container
    class="fill-height"
    :class="$style.loginPageView"
    :style="{ backgroundImage: `url(${loginBgUrl})` }"
    fluid
  >
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" class="min-w-112">
        <login-form :loading="isLoading" @submit="handleSubmit" />
      </v-col>
    </v-row>
  </v-container>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
.loginPageView {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}
</style>
